export default __webpack_public_path__ + "static/media/Reduced Annual Precipitation d7b0d92625ac494182382f2d0a40ad65.50d5457c.md";